import React from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@sg/garnish';

export const CustomizationFooterButtonsContainer = (props: Props) => {
  const { children } = props;

  return <View style={styles.container}>{children}</View>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing['4'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  children: React.ReactNode;
};
